export default __webpack_public_path__ + "static/media/profile.62312b0f.png";